export default __webpack_public_path__ + "media/color/ant-77c68cbc.svg";